import script from "./MCalendario.vue?vue&type=script&lang=ts&setup=true"
export * from "./MCalendario.vue?vue&type=script&lang=ts&setup=true"

import "./MCalendario.vue?vue&type=style&index=0&id=3d126101&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d126101"]])

export default __exports__